<template>
  <div class="h-screen min-h-full flex">
    <div class="flex-1 flex flex-col justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
      <div class="mx-auto w-full max-w-sm lg:w-96">
        <div>
          <img class="h-12 w-auto" src="@/assets/chatpilot-long.svg" alt="Chatpilot.io" />
          <h2 class="mt-6 text-3xl font-extrabold text-gray-900">Join Chatpilot.io</h2>
        </div>
        <div class="mt-8">
          <div class="mt-6">
            <form v-on:submit="joinAction" class="space-y-6">
              <div>
                <label for="password" class="block text-sm font-medium text-gray-700"> Password </label>
                <div class="mt-1">
                  <input autofocus id="password" v-model="password" required name="password" type="password" autocomplete="current-password" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                </div>
              </div>

              <div class="space-y-1">
                <label for="password_repeat" class="block text-sm font-medium text-gray-700"> Password again </label>
                <div class="mt-1">
                  <input id="password_repeat" v-model="password_repeat" required name="password" type="password" autocomplete="current-password" class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                </div>
              </div>
              <div v-if="error" class="text-red-600 font-bold font-sm">
                {{error}}
              </div>
              <div>
                <button v-bind:disabled="disableSubmit" type="submit" class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                v-bind:class="{ 'disabled-submit bg-gray-400 hover:bg-gray-400': disableSubmit, 'bg-indigo-600 hover:bg-indigo-700': !disableSubmit }">Join</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="hidden lg:block relative w-0 flex-1">
      <img class="absolute inset-0 h-full w-full object-cover" src="@/assets/login_cover.jpg" alt="" />
    </div>
  </div>
</template>

<script>
import agentModel from '@/models/agent';

export default {
  name: 'JoinPage',
  created: function () {
    setTimeout(() => {
      document.getElementById('password').focus();
    }, 0);
  },
  methods: {
    async joinAction(e) {
      e.preventDefault();
      this.error = '';
      let agentData = agentModel.buildActivationData(this.password, this.activationToken);
      let response;
      try {
        response = await agentModel.activateAgent(agentData, this.axios);
      } catch(error) {
        this.error = 'Activation link expired.';
      }
      if (response && response.status === 201) {
        if (response.data.status === 'ok') {
          this.sendLoginRequest(response.data.email, this.password);
        }
        if (response.data.status === 'already_active') {
          this.error = 'Already activated.';
          setTimeout(() => {
            this.$root.currentRoute = '/';
          }, 3000);
        }
      }
    },
    sendLoginRequest(email, password) {
      let requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email, password: password })
      };
      fetch("/authentication/login/", requestOptions)
        .then(response => {
          if (response.status === 201) {
            this.$emit('authentication-event');
            this.$root.currentRoute = '/';
          } else {
            this.$root.currentRoute = '/';
          }
        });
    },
  },
  computed: {
    disableSubmit() {
      return (!this.password_repeat || !this.password) || this.password !== this.password_repeat;
    },
    activationToken: function () {
      return this.$root.RouteArgs[0];
    },
  },
  data() {
    return {
      password_repeat: undefined,
      password: undefined,
      error: undefined,
    }
  },
}
</script>
